<template>
  <div class="midlogin mid-auth-container h-100">
    <div class="h-100">
      <div class="row h-100 m-0">
        <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 my-auto" id="myIrishDateFormDiv">
          <Login titleH2="" 
          welcomeHeader="Welcome to MyIrishDate!"
          welcomeSubheader="Please sign-in to your account."
          logoSrc="my-irish-date/logo-login.png" guard="MID" 
          clientLink="my_irish_date"/>
        </div>
        <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 my-auto h-100 p-0">
          <div class="h-100" id="myIrishDateImgDiv">
            <img
              class="img-fluid mx-auto"
              id="myIrishDateIconImg"
              src="@/assets/images/my-irish-date/mid-icon.png"
              alt="mid Logo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "@/components/auth/Login.vue";

export default {
  name: "MIDLogin",
  components: { Login },
  data() {
    return {};
  },
  methods: {
    onSubmit() {
      console.log("submit login");
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../css/my-irish-date-fonts.css";
@import "../css/my-irish-date-auth-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/my_irish_date/auth/LoginView.vue